import { useContext } from 'react';
import { AppContext } from 'providers/AppProvider';
import { FLOW_TYPE, TEST_TYPE_INT } from 'consts';
import { useRiskq } from 'hooks/useRiskq';
import {
	Footer,
	ProgressBar,
	Questions,
	RiskqDescription,
	RiskqLegend,
	RiskqText,
	RiskqTextBottom,
	RiskqTitle
} from 'components';

export function Appropriateness() {
	const { flowType } = useContext(AppContext);
	const isRRSU = FLOW_TYPE.RR_SU === flowType;
	const testTypeInt = isRRSU ? TEST_TYPE_INT.NONE : TEST_TYPE_INT.APPROPRIATENESS;
	const ctx = useRiskq(testTypeInt);
	return (
		<ProgressBar {...ctx}>
			<RiskqTitle {...ctx} />
			<RiskqText {...ctx} />
			<RiskqDescription {...ctx} />
			<RiskqLegend {...ctx} />
			<Questions {...ctx} />
			<RiskqTextBottom />
			<Footer {...ctx} />
		</ProgressBar>
	);
}
